export interface VisitRequestKeyParams {
  shortId?: string | null;
  referralMessageId?: string | null;
  appointmentId?: string | null;
}

export function buildVisitRequestKey({
  shortId,
  referralMessageId,
  appointmentId,
}: VisitRequestKeyParams): string {
  return [shortId || '', referralMessageId || '', appointmentId || ''].join('|');
}

export function shouldRefreshVisitBeforeMutation({
  requestKey,
  lastSyncedRequestKey,
}: {
  requestKey: string;
  lastSyncedRequestKey: string | null;
}): boolean {
  return requestKey.length > 0 && requestKey !== lastSyncedRequestKey;
}
